import { apiClients } from '../config/apiClient';

/**
 * Servicio para gestión de usuarios
 */
class UserAPI {
  constructor() {
    this.client = apiClients.users;
  }

  /**
   * Obtener lista de todos los usuarios con información de cuotas (solo admin)
   * @returns {Promise<Object>} Lista de usuarios con cuotas
   */
  async getAllUsersWithQuotas() {
    try {
      const response = await this.client.get('/admin/all');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Error al obtener usuarios',
        statusCode: error.response?.status
      };
    }
  }

  /**
   * Cambiar estado activo/inactivo de un usuario
   * @param {number} userId - ID del usuario
   * @param {boolean} isActive - Nuevo estado
   * @returns {Promise<Object>} Resultado de la operación
   */
  async toggleUserStatus(userId, isActive) {
    try {
      const response = await this.client.put(`/admin/${userId}/toggle-status`, {
        is_active: isActive
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Error al cambiar estado del usuario',
        statusCode: error.response?.status
      };
    }
  }

  /**
   * Crear un nuevo usuario
   * @param {Object} userData - Datos del usuario
   * @returns {Promise<Object>} Resultado de la operación
   */
  async createUser(userData) {
    try {
      // Los usuarios se crean a través del endpoint de autenticación
      const response = await apiClients.auth.post('/register', userData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Error al crear usuario',
        statusCode: error.response?.status
      };
    }
  }

  /**
   * Validar estructura de datos de usuario
   * @param {Array} users - Lista de usuarios
   * @returns {Array} Lista de usuarios validados
   */
  validateUsersData(users) {
    if (!Array.isArray(users)) {
      return [];
    }

    return users.map((user, index) => {
      if (typeof user !== 'object' || user === null) {
        return null;
      }
      
      if (!user.id) {
        return null;
      }
      
      return user;
    }).filter(user => user !== null);
  }

  /**
   * Procesar respuesta del backend para extraer datos de usuarios
   * @param {Object} responseData - Respuesta del backend
   * @returns {Array} Lista de usuarios procesados
   */
  processUsersResponse(responseData) {
    let usersData;
    
    if (responseData.data && Array.isArray(responseData.data)) {
      usersData = responseData.data;
    } else if (Array.isArray(responseData)) {
      usersData = responseData;
    } else {
      throw new Error('Estructura de datos del backend no reconocida');
    }
    
    return this.validateUsersData(usersData);
  }
}

// Crear instancia singleton
export const userAPI = new UserAPI();
export default UserAPI;
